// motor/pipeline.js
import { limpiarBasuraXml } from '../preproceso/limpiarBasuraXml.js'
import { reconstruirPlaceholders } from '../preproceso/reconstruirPlaceholders.js'
import { expandirTablas } from '../preproceso/expandirTablas.js'
import { extraerExpresiones } from '../lectura/extraerExpresiones.js'
import { normalizarPlaceholders } from '../normalizacion/normalizarPlaceholders.js'
import { ejecutarExpresion } from './ejecutarExpresion.js'
import { reemplazarTextoPlano } from '../resolucion/reemplazarTextoPlano.js'
import { resolverImagenes } from '../resolucion/resolverImagenes.js'
import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'

import { parser } from './parser.js'

/**
 * Procesa un DOCX completo aplicando:
 * → reconstrucción de tags
 * → normalización
 * → resolución de variables v: e i:
 * → funciones personalizadas
 * → reemplazo de imágenes base64
 */
export async function procesarDocx(blob, variables, expresiones, datos) {
  const isDev = process.env.NODE_ENV !== 'production'
  const errors = []
  const arrayBuffer = await blob.arrayBuffer()
  const zip = new PizZip(arrayBuffer)

  const archivos = ['document.xml', 'header1.xml', 'footer1.xml']

  // =======================
  // 1️⃣ Preprocesado del XML
  // =======================
  for (const archivo of archivos) {
    const file = zip.file(`word/${archivo}`)
    if (!file) continue

    let xml = file.asText()

    xml = limpiarBasuraXml(xml)
    xml = reconstruirPlaceholders(xml)
    xml = expandirTablas(xml, datos, variables, expresiones, errors)

    zip.file(`word/${archivo}`, xml)
  }

  // ===================================
  // 2️⃣ Detectar y normalizar placeholders
  // ===================================
  for (const archivo of archivos) {
    const file = zip.file(`word/${archivo}`)
    if (!file) continue

    let xml = file.asText()
    const placeholders = extraerExpresiones(xml)
    if (isDev) {
      console.debug('[formatos] placeholders', archivo, placeholders.map((p) => p.tag))
    }

    const { mapaFinal } = normalizarPlaceholders(placeholders, variables, expresiones, errors)
    if (isDev) {
      console.debug('[formatos] mapaFinal', archivo, mapaFinal)
    }

    // Reemplazar por expresiones normalizadas
    for (const ph of placeholders) {
      xml = xml.replace(ph.tag, mapaFinal[ph.tag])
    }

    zip.file(`word/${archivo}`, xml)
  }
  // ===================================================
  // 3️⃣ Ejecutar Docxtemplater para v: y funciones base
  // ===================================================
  /*const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
    nullGetter: () => 'no encontrado',
    delimiters: { start: '${', end: '}' },
    parser, // <-- ESTA LÍNEA ES CRÍTICA
  })

  doc.render(datos)*/
  for (const archivo of archivos) {
    const file = zip.file(`word/${archivo}`)
    if (!file) continue

    let xml = file.asText()

    // REEMPLAZO PROPIO
    xml = reemplazarTextoPlano(xml, datos, errors)

    zip.file(`word/${archivo}`, xml)
  }

  // ===================================
  // 4️⃣ Resolver imágenes i:
  // ===================================
  for (const archivo of archivos) {
    const file = zip.file(`word/${archivo}`)
    if (!file) continue

    let xml = file.asText()
    xml = resolverImagenes(xml, datos, zip, archivo, errors)
    zip.file(`word/${archivo}`, xml)
  }

  // ===================================================
  // 5️⃣ Generar DOCX final
  // ===================================================
  if (isDev && errors.length) {
    console.warn('[formatos] errores', errors)
  }

  return { blob: zip.generate({ type: 'blob' }), errors }
}
